<template>
    <div class="client-areas-page">
        <app-sub-title text="Áreas de la Empresa" />
        <div class="client-areas-page-buttons">
            <button class="btn btn-primary" @click="openForm">
                <i class="fa fa-plus"></i> Crear Área
            </button>
        </div>
        <app-client-areas-filters
            :venues="venues"
            :onFilter="onFilter"
            :onClearFilters="onClearFilters"
        />
        <app-client-areas-list
            :data="data"
            :on-change-page="onChangePage"
            :on-edit="onEdit"
            :on-delete="onDelete"
            @sort="onSort"
        />

        <!-- PopUps -->
        <app-pop-up
            id="client-area-form"
            :title="!area ? 'Crear Área' : 'Editar Área'"
            :on-close="() => $bus.$emit('client-area-form.clear')"
        >
            <div slot="body">
                <app-client-area-form
                    :selected-area="area"
                    :venues="venues"
                    :on-save="onSave"
                    id="client-area-form"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-primary"
                    :disabled="inProgress"
                    @click="saveArea"
                >
                    <i class="fa fa-save"></i> Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            id="client-area-delete-confirm"
            title="Confirmar Eliminación"
            :on-close="closeDeleteModal"
        >
            <div slot="body">
                <p class="text-danger">
                    <i class="fa fa-exclamation-triangle"></i>
                    Esta acción no se puede deshacer.
                </p>
                <p>
                    ¿Está seguro de eliminar el área
                    <strong>"{{ areaToDelete ? areaToDelete.name : '' }}"</strong>?
                </p>
            </div>
            <div slot="buttons">
                <button class="btn btn-danger" @click="confirmDelete" :disabled="deleting">
                    <i class="fa fa-trash"></i> Eliminar
                </button>
            </div>
        </app-pop-up>
        <!-- Fin PopUps -->
    </div>
</template>
<script>
import clientAreasRepository from "../../../repositories/client-areas.repository";
import clientsRepository from "../../../repositories/clients.repository";
import SubTitle from "../../UI/Layout/SubTitle.vue";
import ClientAreasList from "./ClientAreasList.vue";
import ClientAreasFilters from "./ClientAreasFilters.vue";
import ClientAreaForm from "./ClientAreaForm.vue";
import { mapGetters } from "vuex";

export default {
    components: {
        appSubTitle: SubTitle,
        appClientAreasList: ClientAreasList,
        appClientAreasFilters: ClientAreasFilters,
        appClientAreaForm: ClientAreaForm
    },
    data() {
        return {
            data: {},
            page: 1,
            filters: {},
            area: null,
            areaToDelete: null,
            venues: [],
            deleting: false,
            sort: {
                sortBy: "name",
                sortDir: "asc"
            }
        };
    },
    computed: {
        ...mapGetters(["client", "user"])
    },
    methods: {
        async loadAreas() {
            try {
                const filters = {
                    ...this.filters,
                    page: this.page
                };
                const { data } = await clientAreasRepository.get(filters);
                this.data = data;
            } catch (error) {
                toastr.error("Ocurrió un error al cargar las áreas");
            }
        },
        loadVenues() {
            if (this.client && this.client.id) {
                const cr = { ...clientsRepository };
                cr.getVenuesByClient(this.client.id)
                    .then(data => {
                        this.venues = data.map(venue => ({
                            id: venue.id,
                            name: venue.name
                        }));
                    })
                    .catch(error => {
                        toastr.error("Ocurrió un error al cargar las sedes");
                    });
            }
        },
        onChangePage(page) {
            this.page = page;
            this.loadAreas();
        },
        onEdit(area) {
            this.area = area;
            this.openForm();
        },
        onDelete(area) {
            this.areaToDelete = area;
            this.openDeleteModal();
        },
        openDeleteModal() {
            this.$bus.$emit("client-area-delete-confirm.open");
        },
        closeDeleteModal() {
            this.$bus.$emit("client-area-delete-confirm.close");
            this.areaToDelete = null;
        },
        async confirmDelete() {
            if (!this.areaToDelete) {
                return;
            }

            this.deleting = true;
            try {
                const { data } = await clientAreasRepository.delete(this.areaToDelete.id);
                if (data.status) {
                    this.closeDeleteModal();
                    this.loadAreas();
                    toastr.success(data.msg || "El área ha sido eliminada");
                } else {
                    toastr.error(data.msg || "Error al eliminar el área");
                }
            } catch (error) {
                toastr.error("Ocurrió un error al eliminar el área");
            } finally {
                this.deleting = false;
            }
        },
        onFilter(filters) {
            this.page = 1;
            this.filters = filters;
            this.loadAreas();
        },
        onClearFilters() {
            this.page = 1;
            this.filters = {};
            this.loadAreas();
        },
        saveArea() {
            this.$bus.$emit("client-area-form.save");
        },
        onSave() {
            this.closeForm();
            this.loadAreas();
        },
        openForm() {
            this.$bus.$emit("client-area-form.open");
        },
        closeForm() {
            this.$bus.$emit("client-area-form.close");
            this.area = null;
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadAreas();
        }
    },
    created() {
        if (!this.user || this.user.profile.slug !== 'cliente-admin') {
            this.$router.push({ name: 'admin' });
            return;
        }
        this.loadVenues();
        this.loadAreas();
    }
};
</script>

